import { API } from "@/lib/api";
import { APIService, FetchListRequest } from "@/services/api";
import { ReadTimesheetEntryShiftReport } from "@/types/timesheetEntryShiftReport";

const service = new APIService<ReadTimesheetEntryShiftReport>(
  API.TimesheetEntries,
);

export const TimesheetEntriesShiftReportsService = {
  getList: (fetchParams: FetchListRequest<ReadTimesheetEntryShiftReport>) =>
    service.getList(fetchParams, `/shift-reports`),
};
